// extracted by mini-css-extract-plugin
export var container = "focusAreaCard-module--container--74885";
export var info = "focusAreaCard-module--info--ba74c";
export var logo = "focusAreaCard-module--logo--0c1c3";